import type { BaseQueryApi, FetchArgs, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import mergeWith from 'lodash-es/mergeWith';

import { DEV_HUB_URL_STRING } from '../../../constants';

export async function mergeResults(
    currentArgs: string | FetchArgs,
    WebApi: BaseQueryApi,
    extraOptions: any,
    rawBaseQuery: ReturnType<typeof fetchBaseQuery>,
    rawBaseQueryIntegration: ReturnType<typeof fetchBaseQuery>,
    hubUrl?: string,
) {
    /**
     * If currentArgs.url includes 'license-access' and hubUrl is defined, that means I don't need to combine requests but rather do either of them.
     * Otherwise, I would get an unnecessary 403 error trying to access the integration endpoint for the dev instance and vice versa.
     * That's triggered by LincenseGuard.tsx when it checks for the license access.
     * If hubUrl contains 'dev-sqnt', that means I need to use only rawBaseQuery.
     * If hubUrl contains 'integration', that means I need to use only rawBaseQueryIntegration.
     */

    if (isFetchArgs(currentArgs) && currentArgs.url.includes('license-access') && hubUrl) {
        if (hubUrl.includes(DEV_HUB_URL_STRING)) {
            return rawBaseQuery(currentArgs, WebApi, extraOptions);
        }
        if (hubUrl.includes('integration')) {
            return rawBaseQueryIntegration(currentArgs, WebApi, extraOptions);
        }
    }
    const baseResult = await rawBaseQuery(currentArgs, WebApi, extraOptions);
    const resultIntegration = await rawBaseQueryIntegration(currentArgs, WebApi, extraOptions);
    const result = mergeWith(baseResult, resultIntegration, (obj, src) => {
        if (Array.isArray(obj)) return obj.concat(src);
        if (typeof obj === 'boolean' || typeof src === 'boolean')
            return Boolean(obj) || Boolean(src);
        return undefined;
    });
    return result;
}

export function isFetchArgs(args: string | FetchArgs) {
    return typeof args === 'object';
}
